import React from 'react';
import '../styles/PrivacyPolicy.css'; // Optional: for custom styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
    <div className="privacy-policy-container">
      <h1>GuideWell Privacy Policy</h1>
      <p><strong>Effective Date:</strong> April 1, 2026</p>

      <p>
        DTecX LLC (“DTecX,” “we,” “us,” or “our”) operates the GuideWell mobile and web applications
        (collectively, the “Service”). This Privacy Policy explains what information we collect, how
        we use and share it, and your rights regarding your data. By using GuideWell, you agree to
        the practices described in this Policy. We do not sell your personal information.
      </p>

      <section>
        <h2>1. Information We Collect</h2>
        <h3>1.1 Account Information</h3>
        <ul>
          <li>Email address — required for authentication and account management</li>
          <li>Full name — collected during signup</li>
          <li>Password — stored securely via Firebase Authentication (hashed and never stored in plaintext)</li>
          <li>Phone number</li>
          <li>Company name — optional</li>
        </ul>

        <h3>1.2 Property Management Data</h3>
        <ul>
          <li>Property details — names, addresses, and unit information</li>
          <li>Tenant information — names, contact details, and lease information</li>
          <li>Financial records — income, expenses, rent payments, and insurance details</li>
          <li>Lease details — start/end dates, rent amounts, and unit assignments</li>
          <li>Reminders — user-created reminder text and due dates</li>
        </ul>

        <h3>1.3 Authentication and Session Data</h3>
        <ul>
          <li>Login status and session tokens (managed through Firebase Authentication)</li>
          <li>iOS Keychain data — authentication tokens stored in encrypted on-device storage</li>
        </ul>

        <h3>1.4 Usage and Diagnostic Data</h3>
        <ul>
          <li>App interaction data</li>
          <li>Error and crash logs</li>
        </ul>

        <h3>1.5 AI-Processed Data</h3>
        <p>
          GuideWell includes an AI-assisted feature that allows you to upload lease documents to
          automatically extract and pre-fill tenant information. This feature uses the Claude API
          (Anthropic, PBC). Documents are transmitted for processing and are not retained by GuideWell.
        </p>
      </section>

      <section>
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Authenticate your account and manage login sessions</li>
          <li>Provide and operate core app features</li>
          <li>Send account verification and password reset emails</li>
          <li>Display personalized content</li>
          <li>Respond to support requests</li>
        </ul>
        <p>We do not use your information for advertising and we do not sell your data to third parties.</p>
      </section>

      <section>
        <h2>3. Data Storage and Third-Party Services</h2>
        <p>Your data is handled by the following services:</p>
        <ul>
          <li><strong>Firebase (Google):</strong> Email, password hash, authentication tokens.</li>
          <li><strong>GuideWell Backend:</strong> Property management data and user profile information.</li>
          <li><strong>Apple iOS Keychain:</strong> Encrypted authentication tokens.</li>
          <li><strong>Anthropic, PBC:</strong> Lease documents for AI-assisted processing only.</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Sharing</h2>
        <p>
          We only share data necessary to operate the Service, such as authentication data with
          Firebase or lease documents with Anthropic. We do not share your data with advertisers.
        </p>
      </section>

      <section>
        <h2>5. Cookies and Tracking Technologies</h2>
        <p>
          GuideWell uses iOS Keychain and local app storage for authentication tokens and preferences.
          We do not use advertising trackers or cross-site tracking technologies.
        </p>
      </section>

      <section>
        <h2>6. Data Retention</h2>
        <p>
          Account data is retained until account deletion. Diagnostic logs may be retained for up to
          90 days. You can request deletion via the app or contact us.
        </p>
      </section>

      <section>
        <h2>7. User Responsibilities for Third-Party Data</h2>
        <p>
          You are responsible for lawful collection and management of third-party data such as tenant
          information. DTecX is not responsible for how you handle this information.
        </p>
      </section>

      <section>
        <h2>8. Your Privacy Rights</h2>
        <p>
          You may have rights to access, correct, delete, or restrict your personal data. California
          residents have additional CCPA rights.
        </p>
      </section>

      <section>
        <h2>9. Data Security</h2>
        <p>
          We use HTTPS, encrypted storage, and password hashing to protect your data. Absolute security
          cannot be guaranteed.
        </p>
      </section>

      <section>
        <h2>10. Children’s Privacy</h2>
        <p>
          GuideWell is not intended for children under 13. Any information collected from children
          will be deleted.
        </p>
      </section>

      <section>
        <h2>11. Changes to This Policy</h2>
        <p>
          Updates will be reflected in the effective date and communicated through the app or email.
        </p>
      </section>

      <section>
        <h2>12. Contact Us</h2>
        <p>
          DTecX LLC<br />
          Email: <a href="mailto:Support@dtecx.net">Support@dtecx.net</a>
        </p>
      </section>
    </div>
    </div>
  );
};

export default PrivacyPolicy;